var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"app_background"},[_c('v-content',{attrs:{"fluid":""}},[_c('router-view',{attrs:{"color":"primary"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }